export default Object.freeze({
  DEFAULT: 'DEFAULT',
  SEEMORE: 'SEEMORE',
  HEADER: 'HEADER',
  UNIQ_KEY: 'CUSTOMER_ID',
  FIX_ATTACH: 'FIX_ATTACH',
})
